<template>
    <div>
        <input type="hidden" :name="name" :value="timezone" />
    </div>
</template>
<script>
export default {
    props: {
        name: {
            default: 'timezone',
        },
    },
    data() {
        return {
            timezone: '',
        };
    },
    mounted() {
        console.log('mounted');
        this.getTimezone();
    },
    methods: {
        getTimezone() {
            this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        },
    },
};
</script>
